import { type ReactNode, useEffect } from 'react';
import { Navigate } from 'react-router';
import { usePartnerAuthStore } from '@/stores/partnerAuthStore';
import { Skeleton } from '@/components/ui/skeleton';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, fetchMe } = usePartnerAuthStore();

  useEffect(() => {
    // Always re-verify against the server on mount, even when `partner` was
    // rehydrated from localStorage by zustand/persist: a stale cached role
    // (e.g. a self-demoted admin) must not be trusted until fetchMe()
    // confirms it. isLoading gates rendering below in the meantime.
    void fetchMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Skeleton className="h-8 w-40" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}
